import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["arrow"];

  async expand_rows(e) {
    const node = e.currentTarget.parentNode.parentNode;
    this.toggle_arrow(false, e);

    if (node.classList.contains("active")) {
      this.close_rows(node);
      return;
    }

    this.toggle_arrow(true, e);

    node.classList.add("active");

    this.add_spinner(node);
    const index = node.getAttribute("data-index");
    const content = await this.get_new_rows(index);
    await this.put_new_row_after_current(node, content);
    this.remove_spinner();
    this.init_popover();
  }

  close_rows(node) {
    const index = node.getAttribute("data-index");
    this.delete_with_class(index);
    node.classList.remove("active");
  }

  put_new_row_after_current(node, content) {
    node.insertAdjacentHTML("afterend", content);
  }

  toggle_arrow(open, e) {
    e.currentTarget.childNodes.forEach((el) => {
      if(!(el.tagName === "svg" && el.hasAttribute("data-icon")))
        return;
      if (open === true)
        el.setAttribute("data-icon", "angle-down");
      else
        el.setAttribute("data-icon", "angle-right");
    });
  }
  
  add_spinner(node) {
    this.put_new_row_after_current(node, "<div class=\"text-center m-5 text-secondary spinner\"><div class=\"spinner-border\" role=\"status\">\n" +
      "  <span class=\"sr-only\">Loading...</span>\n" +
      "</div></i></div>");
  }

  remove_spinner() {
    const s = document.getElementsByClassName("spinner");
    while(s[0])
      s[0].parentNode.removeChild(s[0]);
  }

  delete_with_class(class_name) {
    const r = document.getElementsByClassName(class_name);
    while (r[0])
      r[0].parentNode.removeChild(r[0]);
  }

  async init_popover() {
    setTimeout(function(){
      // eslint-disable-next-line no-undef
      $(".popover-button").each(function() {
        // eslint-disable-next-line no-undef
        $(this).popover({ trigger: "hover" });
      });
    }, 500);
  }

  async get_new_rows(partner_id) {
    const response = await fetch("/partners/nested_partners/" + partner_id)
      .then(response => response.text())
      .then(html => { return html; });

    return response;
  }
}
